import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette }) => ({
  notification: {
    "& nth:last-child": {
      border: 0,
    },
    borderBottom: `solid 1px ${palette.grey["200"]}`,
    width: "100%",
    maxWidth: "400px",
  },
}));
